import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import CustomerService from '../../../services/CustomerService';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

export interface SendInvitationDialogData {
  customerNo: number;
}

@Component({
  selector: 'app-send-invitation-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatSnackBarModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './send-invitation-dialog.component.html',
  styleUrls: ['./send-invitation-dialog.component.css']
})
export class SendInvitationDialogComponent {
  invitationForm: FormGroup;
  isLoading = false;
  customerNo: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: SendInvitationDialogData,
    private dialogRef: MatDialogRef<SendInvitationDialogComponent>,
    private fb: FormBuilder,
    private customerService: CustomerService,
    private snackBar: MatSnackBar
  ) {
    this.customerNo = data.customerNo;
    this.invitationForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      message: ['', [Validators.required, Validators.maxLength(1000)]]
    });
  }

  get emailControl() {
    return this.invitationForm.get('email');
  }

  get messageControl() {
    return this.invitationForm.get('message');
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSend(): void {
    if (this.invitationForm.valid) {
      this.isLoading = true;
      const { email, message } = this.invitationForm.value;

      // Use the new endpoint that generates invite link and sends email
      this.customerService.sendInviteWithLink(this.customerNo, email, message).subscribe({
        next: (response) => {
          this.isLoading = false;
          this.snackBar.open('Einladung mit Registrierungslink erfolgreich versendet!', 'Schließen', {
            duration: 5000,
            panelClass: ['success-snackbar']
          });
          console.log('Invite link generated:', response.link);
          this.dialogRef.close(true);
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Error sending invitation:', error);
          this.snackBar.open(
            'Fehler beim Versenden der Einladung: ' + (error.error?.message || error.message),
            'Schließen',
            {
              duration: 7000,
              panelClass: ['error-snackbar']
            }
          );
        }
      });
    } else {
      // Mark all fields as touched to show validation errors
      Object.keys(this.invitationForm.controls).forEach(key => {
        this.invitationForm.get(key)?.markAsTouched();
      });
    }
  }
}
